// src/store/paginacionStore.js
import { defineStore } from "pinia";
import { ref } from "vue";

// ── Store para tabla principal de Pedidos ─────────────────
export const userPaginacionStore = defineStore("Pedidos", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];

  function setPorPagina(n) {
    porPagina.value = n;
  }

  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para tabla de Seguimiento ──────────────────────
export const usePaginacionSeguimientoStore = defineStore("PedidosSeguimiento", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];

  function setPorPagina(n) {
    porPagina.value = n;
  }

  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Máquinas ───────────────────────────────────
export const usePaginacionMaquinasStore = defineStore("Maquinas", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Actividades ────────────────────────────────
export const usePaginacionActividadesStore = defineStore("Actividades", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Rutinas ────────────────────────────────────
export const usePaginacionRutinasStore = defineStore("Rutinas", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Refacciones ────────────────────────────────
export const usePaginacionRefaccionesStore = defineStore("Refacciones", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Unidades / Inventario ─────────────────────
export const usePaginacionUnidadesStore = defineStore("Unidades", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Areas de trabajo ─────────────────────
export const usePaginacionAreasStore = defineStore("Areas", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20]; 
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Articulos ─────────────────────
export const usePaginacionArticulosStore = defineStore("Articulos", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20]; 
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Clientes ─────────────────────
export const usePaginacionClientesStore = defineStore("Clientes", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20]; 
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Operadores (Moldsid) ──────────────────────────
export const usePaginacionOperadoresStore = defineStore("Operadores", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Máquinas Moldsid ───────────────────────────────
// (distinto al de máquinas de mantenimiento industrial)
export const usePaginacionMaquinasMoldsidStore = defineStore("MaquinasMoldsid", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Pigmentos ───────────────────────────────────────
export const usePaginacionPigmentosStore = defineStore("Pigmentos", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para TPUs ───────────────────────────────────────────
export const usePaginacionTPUsStore = defineStore("TPUs", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Códigos de Defecto ─────────────────────────────
export const usePaginacionCodigosDefectoStore = defineStore("CodigosDefecto", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Productos ───────────────────────────────────────
export const usePaginacionProductosStore = defineStore("Productos", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Historial Consumo Materia Prima ────────────────
export const usePaginacionConsumoMPStore = defineStore("ConsumoMateriaPrima", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Historial Scrap Almacén y Laser ────────────────
export const usePaginacionScrapAlmacenStore = defineStore("ScrapAlmacenLaser", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para Historial Vena y Scrap ─────────────────────────
export const usePaginacionVenaScrapStore = defineStore("VenaScrap", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });

// ── Store para líneas de Reporte de Producción (Inyección) ────
export const usePaginacionLineasReporteProduccionStore = defineStore("LineasReporteProduccion", () => {
  const porPagina = ref(10);
  const opcionesPorPagina = [5, 10, 15, 20];
  function setPorPagina(n) { porPagina.value = n; }
  return { porPagina, opcionesPorPagina, setPorPagina };
}, { persist: true });